
import HeartModule from "./Heart.module.scss";
import React, {startTransition, useEffect, useMemo, useRef, useState} from "react";
import {ApiClient} from "../../../../../generated/ApiClient";
import {useAbortController} from "../../../../../components/Hook/useAbortController";
import { useMyRadioKey} from "../../../../../queriesKeys/useMyKey";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useIsLoggedUser} from "../../../../../utils/UseIsLoggedUser";
const Overlay =  React.lazy(() =>import ("react-bootstrap/Overlay"));

type Props = {
    className?: string
    slug: string,
    color?: string
}

export const Heart = (props: Props) => {
    const [liked, setLiked] = useState<boolean|undefined>(undefined);
    const [, setRefresh] = useState(0);
    const isUser = useIsLoggedUser();
    const ab = useAbortController();

    const controller = useMemo(()=>{
        return ab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUser, props.slug, ab]);

    const { data: likedRadios } = useQuery(useMyRadioKey(props.slug, !!isUser));
    const queryClient = useQueryClient();

    useEffect(() => {
        startTransition(()=> {
            if (!likedRadios) {
                setLiked(undefined);
            }
            else
            {
                setLiked(likedRadios.some(x => x.slug === props.slug))
            }
        });
    }, [likedRadios, props.slug]);


    const ref = useRef<HTMLAnchorElement|null>(null)
    const [showAlert, setShowAlert] = useState(false);

    return (<>
        {props.color ? <style>{`
          .colorheart {
             background-image: url(${process.env.REACT_APP_API_DOMAIN}/generated/heart/${props.color.toUpperCase().replace("#","")}.svg);
             background-repeat: no-repeat !important;
          }
        `}</style>: null}
        <a href={"#like"} ref={ref} onClick={e=>{
            e.preventDefault();
            if (!isUser)
            {
                setShowAlert(true);
                const t = setTimeout(()=>{
                    setShowAlert(false);
                }, 3000);
                controller.signal.addEventListener("abort",()=>{
                    clearTimeout(t);
                })
                return;
            }
            (async () => {
                setLiked(undefined);
                await new ApiClient().patchApiUserLikeStation({
                    slug: props.slug,
                }, {
                    signal: controller.signal,
                    credentials: "include"
                }).then(()=>{
                    queryClient.invalidateQueries({
                        predicate: ( x ) => (x.queryKey.includes("my"))

                    });
                }).catch(e=> {}).finally(() => {
                    setRefresh(c => c+1);
                });
            })();
        }} className={`${HeartModule.Heart} ${liked ? (HeartModule.Liked) : (props.color ? "colorheart" : "")} ${liked === undefined ? HeartModule.Unknown : ""} ${props.className ?? ""}`} title={"Oblíbené"}>

        </a>
        {isUser ? null :
        <Overlay target={ref.current} show={showAlert} placement={"bottom"}>
            {({
                  placement: _placement,
                  arrowProps: _arrowProps,
                  show: _show,
                  popper: _popper,
                  hasDoneInitialMeasure: _hasDoneInitialMeasure,
                  ...props
              }) => (
                <div
                    {...props}
                    style={{
                        position: 'absolute',
                        backgroundColor: 'rgba(255, 100, 100, 0.85)',
                        padding: '2px 10px',
                        color: 'white',
                        borderRadius: 10,
                        ...props.style,
                    }}
                >
                    Pro tuto funkci je potřeba být přihlášen
                </div>
            )}
        </Overlay>}
    </>);
}